import { faBook, faDoorOpen } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import chapterSound from '../../assets/audio/GP_Draw_4.wav';
import navigateButton from '../../assets/audio/UI_Select_2.wav';
import bookImage from '../../assets/book/TheLegendsOfCragknoll.png';
import { chapter1 } from '../../assets/book/chapter1';
import { chapter2 } from '../../assets/book/chapter2';
import { chapter3 } from '../../assets/book/chapter3';
import { chapter4 } from '../../assets/book/chapter4';
import { chapter5 } from '../../assets/book/chapter5';
import { chapter6 } from '../../assets/book/chapter6';
import { chapter7 } from '../../assets/book/chapter7';
import { chapter8 } from '../../assets/book/chapter8';
import { chapter9 } from '../../assets/book/chapter9';
import { Button, Card, Col, Row, Space } from 'antd';
import { FC, useCallback, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';


import { useBookStore } from '../store/game.store';

interface BookPageProps extends React.PropsWithChildren {}
const WarScholarBookProps: FC<BookPageProps> = () => {
   const { state } = useBookStore();
   const { hasUnlockedChapter2, hasUnlockedChapter3, hasUnlockedChapter4, hasUnlockedChapter5, hasUnlockedChapter6, hasUnlockedChapter7, hasUnlockedChapter8, hasUnlockedChapter9 } = state;

   const allChapters = useMemo(() => [chapter1, chapter2, chapter3, chapter4, chapter5, chapter6, chapter7, chapter8, chapter9], []);

   const [getActiveChapter, setActiveChapter] = useState(chapter1);

   const setChapter1ToBeActive = useCallback(() => {
      new Audio(chapterSound).play();
      setActiveChapter(allChapters[0]);
   }, [allChapters]);

   const setChapter2ToBeActive = useCallback(() => {
      new Audio(chapterSound).play();
      setActiveChapter(allChapters[1]);
   }, [allChapters]);

   const setChapter3ToBeActive = useCallback(() => {
      new Audio(chapterSound).play();
      setActiveChapter(allChapters[2]);
   }, [allChapters]);

   const setChapter4ToBeActive = useCallback(() => {
      new Audio(chapterSound).play();
      setActiveChapter(allChapters[3]);
   }, [allChapters]);

   const setChapter5ToBeActive = useCallback(() => {
      new Audio(chapterSound).play();
      setActiveChapter(allChapters[4]);
   }, [allChapters]);

   const setChapter6ToBeActive = useCallback(() => {
      new Audio(chapterSound).play();
      setActiveChapter(allChapters[5]);
   }, [allChapters]);

   const setChapter7ToBeActive = useCallback(() => {
      new Audio(chapterSound).play();
      setActiveChapter(allChapters[6]);
   }, [allChapters]);

   const setChapter8ToBeActive = useCallback(() => {
      new Audio(chapterSound).play();
      setActiveChapter(allChapters[7]);
   }, [allChapters]);

   const setChapter9ToBeActive = useCallback(() => {
      new Audio(chapterSound).play();
      setActiveChapter(allChapters[8]);
   }, [allChapters]);

   const pairs = [];
   for (let i = 1; i < getActiveChapter.length; i += 2) {
      const pair = [getActiveChapter[i - 1], getActiveChapter[i]];
      pairs.push(pair);
   }

   const playNavigationSound = () => {
      new Audio(navigateButton).play();
   };

   return (
      <div className="flex-1 flex flex-col p-2">
         <Space size="large">
            <Link to="/warscholar">
               <button onClick={playNavigationSound}>
                  <FontAwesomeIcon icon={faDoorOpen} /> Back
               </button>
            </Link>
         </Space>

         <Space size="large">
            <div className="padThatBottom">
               <Card
                  title={
                     <a
                        className="App-link"
                        href="https://www.amazon.com/Legends-Cragknoll-Reece-Hewitt-ebook/dp/B09BBSP3SS"
                        target="_blank"
                        rel="noopener noreferrer"
                     >
                        The Legends of Cragknoll
                     </a>
                  }
                  className="height300 width395 padThatBottom"
               >
                  <Row>
                     <Col span={24}>
                        <img
                           src={bookImage}
                           alt="bookImage"
                           className="height180"
                        />
                     </Col>
                     <Col span={24}>
                        The internationally recognized book/ebook available on{' '}
                        <a
                           href="https://www.amazon.com/Legends-Cragknoll-Reece-Hewitt-ebook/dp/B09BBSP3SS"
                           target="_blank"
                           rel="noopener noreferrer"
                        >
                           kindle
                        </a>
                     </Col>
                  </Row>
               </Card>
            </div>
         </Space>

         <Space size="large">
            <Button
               type="primary"
               onClick={setChapter1ToBeActive}
               icon={
                  <FontAwesomeIcon
                     icon={faBook}
                     className="text-white"
                  />
               }
            >
               chapter 1
            </Button>

            <Button
               type="primary"
               onClick={setChapter2ToBeActive}
               disabled={!hasUnlockedChapter2}
               icon={
                  <FontAwesomeIcon
                     icon={faBook}
                     className="text-white"
                  />
               }
            >
               chapter 2
            </Button>

            <Button
               type="primary"
               onClick={setChapter3ToBeActive}
               disabled={!hasUnlockedChapter3}
               icon={
                  <FontAwesomeIcon
                     icon={faBook}
                     className="text-white"
                  />
               }
            >
               chapter 3
            </Button>
         </Space>

         <Space size="large">
            <Button
               type="primary"
               onClick={setChapter4ToBeActive}
               disabled={!hasUnlockedChapter4}
               icon={
                  <FontAwesomeIcon
                     icon={faBook}
                     className="text-white"
                  />
               }
            >
               chapter 4
            </Button>

            <Button
               type="primary"
               onClick={setChapter5ToBeActive}
               disabled={!hasUnlockedChapter5}
               icon={
                  <FontAwesomeIcon
                     icon={faBook}
                     className="text-white"
                  />
               }
            >
               chapter 5
            </Button>

            <Button
               type="primary"
               onClick={setChapter6ToBeActive}
               disabled={!hasUnlockedChapter6}
               icon={
                  <FontAwesomeIcon
                     icon={faBook}
                     className="text-white"
                  />
               }
            >
               chapter 6
            </Button>
         </Space>

         <Space size="large">
            <Button
               type="primary"
               onClick={setChapter7ToBeActive}
               disabled={!hasUnlockedChapter7}
               icon={
                  <FontAwesomeIcon
                     icon={faBook}
                     className="text-white"
                  />
               }
            >
               chapter 7
            </Button>

            <Button
               type="primary"
               onClick={setChapter8ToBeActive}
               disabled={!hasUnlockedChapter8}
               icon={
                  <FontAwesomeIcon
                     icon={faBook}
                     className="text-white"
                  />
               }
            >
               chapter 8
            </Button>

            <Button
               type="primary"
               onClick={setChapter9ToBeActive}
               disabled={!hasUnlockedChapter9}
               icon={
                  <FontAwesomeIcon
                     icon={faBook}
                     className="text-white"
                  />
               }
            >
               chapter 9
            </Button>
         </Space>

         <Space size="large">
            <div className="book-scrollable">
               {pairs.map((pair, index) => (
                  <div key={index}>
                     <p className="book-top-pair">{pair[0]}</p>
                     <p className="book-bottom-pair">{pair[1]}</p>
                  </div>
               ))}
            </div>
         </Space>
      </div>
   );
};

export const WarScholarBookPage = WarScholarBookProps;
